import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { mergeMap, catchError, flatMap } from 'rxjs/operators';
import { combineEpics } from 'web-app/util/redux-observable';
import EmployeeApi from 'signin-app/api/employee-api';
import { dispatchStatusMessageEvent } from '@famly/stat_ts-utils_global-messages';
import { getRestClientErrorMessage } from 'signin-app/api/clients/get-rest-client-error-message';
import { defaultErrorDuration, defaultSuccessDuration } from 'web-app/react/global-event/helpers/constants';
import translate from 'signin-app/helpers/translate';
import { makeEmployeeName } from 'signin-app/employee/selectors';
import * as Actions from './actions';
const checkOutEmployee = (action$, state$) => action$.pipe(ofType(Actions.checkOutEmployee.type), mergeMap(({ payload }) => {
    const { accessToken, employeeId } = payload;
    return EmployeeApi.checkOut(accessToken, employeeId).pipe(flatMap(response => {
        const state = state$.value;
        const getEmployeeName = makeEmployeeName();
        const employeeName = getEmployeeName(state, { employeeId });
        dispatchStatusMessageEvent({
            message: translate('signOutSuccess', { personName: employeeName }),
            statusType: 'Success',
            sticky: false,
            e2eId: '',
            duration: defaultSuccessDuration,
        });
        return [Actions.checkOutEmployeeSuccess.action(response)];
    }), catchError(e => {
        dispatchStatusMessageEvent({
            message: getRestClientErrorMessage(e),
            statusType: 'Error',
            sticky: false,
            e2eId: '',
            duration: defaultErrorDuration,
        });
        return of(Actions.checkOutEmployeeFailed.action(e));
    }));
}));
export default combineEpics(checkOutEmployee);
